import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, ButtonResponsiveWrapper, GoPaperlessIcon, useResponsive } from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import { BannerStorageKey } from '@/modules/core/components/Dashboard/components/BannersList/bannersList.constants';
import useDismissBanner from '@/modules/core/components/Dashboard/components/BannersList/hooks/useDismissBanner';

interface Props {
  handleOpenModal: () => void;
}

const GoPaperlessBanner: React.FC<Props> = ({ handleOpenModal }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { handleDismissBanner } = useDismissBanner();

  const handleDismiss = useCallback(() => {
    handleDismissBanner(BannerStorageKey.GoPaperlessBanner);
  }, [handleDismissBanner]);

  return (
    <Banner
      title={t('Go Paperless')}
      description={t('Enjoy the convenience of paperless transactions and reduce your environmental impact.')}
      icon={<GoPaperlessIcon />}
      testId="go-paperless"
    >
      <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
        <AppButton fill={isMobile} testId="open-popup" onClick={handleOpenModal} width="180px">
          {t('Sign Up')}
        </AppButton>

        <AppButton
          fill={isMobile}
          testId="dismiss-banner"
          buttonType="secondary"
          width="180px"
          onClick={handleDismiss}
        >
          {t('Dismiss')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </Banner>
  );
};

export default GoPaperlessBanner;
